import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ViewPropsType = {
  onClick: () => void;
};

export const View: React.FC<ViewPropsType> = ({ onClick }) => {
  const { t } = useTranslation('common');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  const label = t('ACTIONS.VIEW');

  return (
    <Tooltip label={label}>
      <UnstyledButton onClick={handleClick} aria-label={label}>
        <FontAwesomeIcon icon={faEye} />
      </UnstyledButton>
    </Tooltip>
  );
};
